import {
  Box,
  TextField,
  Typography,
  Button,
  Alert,
  Snackbar,
  Grid,
  Paper
} from "@mui/material";

import { useParams, useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { useApi } from "../api/useApi";
import BackButton from "../components/BackButton";

function CategoryForm() {
  const { domain } = useParams();
  const { uiConfig } = useOutletContext();
  const { request, response } = useApi();

  const [formData, setFormData] = useState([]);
  const [error, setError] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await request({
          url: "/domain-weightages/" + domain,
          method: "GET"
        });

        setFormData(data.categories || []);
      } catch (err) {
        console.error(err);
        setError("Unable to load categories");
      }
    };

    loadData();
  }, [domain]);

  const handleChange = (index, field, value) => {
    const updated = [...formData];

    updated[index] = {
      ...updated[index],
      [field]:
        field === "weightage"
          ? Number(value)
          : value
    };

    setFormData(updated);
  };

  const getTotalWeightage = () => {
    return formData.reduce(
      (sum, item) => sum + Number(item.weightage || 0),
      0
    );
  };

  const handleSubmit = async () => {
    const totalWeightage = formData.reduce(
        (sum, item) => sum + Number(item.weightage || 0),
        0
    );

    // validation
    if (totalWeightage !== 100) {
        setError(
        `Total weightage must equal 100. Current total: ${totalWeightage}`
        );
        return;
    }

    setError("");
    console.log('result from useAPI', response);
    const data = await request({ url: '/domains-with-categories' });
    const domainID = data.find(d => d.name.toLowerCase() === domain.toLowerCase())?.id;
    console.log('domainID',domainID);

    try {
        const payload = {
        name: domain.toUpperCase(), 
        id: domainID,
        categories: formData.map((item) => ({
            id: item.id,
            name: item.name,
            weightage: Number(item.weightage)
        }))
        };

        console.log("Submitting payload:", payload);

        const response = await request({
        url: "/domain-weightages",
        method: "POST",
        data: payload
        });

        console.log("Save success:", response);

        setSuccessMessage("Categories updated successfully");
        setSuccessOpen(true);

        setTimeout(() => {
        setSuccessOpen(false);
        }, 3000);

    } catch (err) {
        console.error(err);

        setError(
        err?.response?.data?.message ||
        "Unable to save category details"
        );
    }
    };

  const handleCancel = () => {
    //setFormData(categories);
    setError("");
  };

  return (
          <Grid container component="main" sx={{ minHeight: "90vh", position: "relative", display: "flex", justifyContent: "center", alignItems: "center", p: 2 }}>
            <Paper sx={{ display: "flex", p: 4, borderRadius: 4, maxWidth: "100%", width: "77vw", overflowY: "auto", boxShadow: 6, background: "rgba(255,255,255,0.15)", backdropFilter: "blur(5px) saturate(180%)", flexDirection: "column" }}>

    <Box sx={{ p:4, maxWidth:"900px" }}>
      <BackButton/>
      <Typography
        variant="h5"
        sx={{
          mb:4,
          fontWeight:600
        }}

      >
        {domain.toUpperCase()} Categories
      </Typography>

      {formData.map((cat,index)=>(
        <Box
          key={cat.id}
          sx={{
            display:"flex",
            gap:3,
            mb:3
          }}
        >
          <TextField
            fullWidth
            label="Category Name"
            value={cat.name}
            onChange={(e)=>
              handleChange(
                index,
                "name",
                e.target.value
              )
            }
          />

          <TextField
            label="Weightage"
            type="number"
            value={cat.weightage}
            sx={{width:"200px"}}
            onChange={(e)=>
              handleChange(
                index,
                "weightage",
                e.target.value
              )
            }
          />
          <Snackbar
            open={successOpen}
            autoHideDuration={3000}
            onClose={() => setSuccessOpen(false)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
          >
            <Alert
              severity="success"
              variant="filled"
              onClose={() => setSuccessOpen(false)}
            >
              {successMessage}
            </Alert>
          </Snackbar>
        </Box>
      ))}

      <Typography
        sx={{
          mt:2,
          fontWeight:600
        }}
      >
        Total Weightage: {getTotalWeightage()}
      </Typography>

      {error && (
        <Alert
          severity="error"
          sx={{mt:2}}
        >
          {error}
        </Alert>
      )}

      <Box
        sx={{
          mt:4,
          display:"flex",
          gap:2
        }}
      >
        <Button
          variant="contained"
          onClick={handleSubmit}
        >
          Submit
        </Button>

        <Button
          variant="outlined"
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </Box>
    </Box>
    </Paper>
    </Grid>
  );
}

export default CategoryForm;